import { css } from '@emotion/core'
import { link } from './linkMixin'

export default ({ theme }) => css`
  display: flex;
  justify-content: center;
  padding: 1rem;

  .prev-button,
  .next-button {
    ${link}
    background-color: ${theme.colors.alt1};
    color: ${theme.colors.complementary.primary};
    padding: 1rem 1.3rem;
    transition: background 0.2s ease;

    &:hover {
      background-color: ${theme.colors.complementary.alt1};
      color: ${theme.colors.complementary.primary};
    }
  }

  .paginate-text {
    padding: 0 2rem;
  }

  .disabled {
    opacity: 0.25;
    pointer-events: none;
  }

  .page-count {
    margin: 0 2rem;
  }

  .page-count-prefix {
    texttransform: uppercase;
  }
`
